import { z } from 'zod';
export const registerToTradingCompetitionInputSchema = z.object({
    address: z.string().min(1, 'Address is required'),
    metadata: z
        .object({
        webhookId: z.string().optional(),
    })
        .optional(),
});
export const registerToTradingCompetitionOutputSchema = z.object({
    id: z.string(),
    userId: z.string(),
    communityId: z.string(),
    tradingCompetitionId: z.string(),
    address: z.string(),
    metadata: z
        .object({
        webhookId: z.string().optional(),
    })
        .optional(),
});
